<template>
  <div id="dbSchema">
    <a-table
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange
      }"
      :columns="columns"
      :dataSource="dbSchemaList"
      :pagination="Nopagination"
      :loading="loading"
      size="small"
      :scroll="{y: '75vh'}"
      :locale="tabelText"
    >
      <template
        v-for="(item, index) in scopedSlotsArray"
        :slot="item"
        slot-scope="text"
      >
        <span :key="index">
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span class="tableFontSize">{{
                text === "1" || text === true ? "Yes" : text === "0" || text === false ? "No" : text === "" ? "-" : text
              }}</span>
            </template>
            <div class="tableFontSize">
              {{text === "1" || text === true ? "Yes" : text === "0" || text === false ? "No" : text === "" ? "-" : text}}
            </div>
          </a-tooltip>
        </span>
      </template>
    </a-table>
  </div>
</template>
<script>
import { mapState } from "vuex";
import ajax from "../../../api/ajax";
import api from "../../../api/url";
export default {
  data() {
    return {
      tabelText: {
        emptyText: "No record found"
      },
      Nopagination: false,
      selectedRowKeys: [],
      dbSchemaList: [],
      loading: false,
      scopedSlotsArray: [
        "TableName",
        "FieldName",
        "Mandatory",
        "FieldType",
        "FieldLength",
        "Decimal",
        "FKTab",
        "FKFieldName"
      ]
    };
  },

  computed: {
    columns() {
      return [
        {
          title: this.$t("generic.TableName"),
          dataIndex: "TableName",
          scopedSlots: { customRender: "TableName" },
          width: 150
        },
        {
          title: this.$t("generic.FieldName"),
          dataIndex: "FieldName",
          scopedSlots: { customRender: "FieldName" },
          width: 200
        },
        {
          title: this.$t("generic.Mandatory"),
          dataIndex: "Mandatory",
          scopedSlots: { customRender: "Mandatory" }
        },
        {
          title: this.$t("generic.FieldType"),
          dataIndex: "FieldType",
          scopedSlots: { customRender: "FieldType" }
        },
        {
          title: this.$t("generic.FieldLength"),
          dataIndex: "FieldLength",
          scopedSlots: { customRender: "FieldLength" }
        },
        {
          title: this.$t("generic.Decimal"),
          dataIndex: "Decimal",
          scopedSlots: { customRender: "Decimal" }
        },
        {
          title: this.$t("generic.FKTable"),
          dataIndex: "FKTable",
          scopedSlots: { customRender: "FKTable" }
        },
        {
          title: this.$t("generic.FKFieldName"),
          dataIndex: "FKFieldName",
          scopedSlots: { customRender: "FKFieldName" }
        }
      ];
    },
    ...mapState(["uid"]) // 获取uid
  },

  watch: {
    uid(val) {
        this.initTable()
    }
  },
    created() {
        this.initTable();
    },
  methods: {
    initTable() {
      if (this.uid === "") {
        return;
      }
      this.loading = true;
      let params = {
        uid: this.uid
      };
      ajax.get(api.GETSCHEMADETAIL, params).then(res => {
        this.dbSchemaList = res.data;
        this.loading = false;
        this.selectedRowKeys = [];
      });
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.$emit("QuerydbSelectList", selectedRows);
    }
  }
};
</script>
<style lang="less">
#dbSchema {
  margin: 10px 0;
}
</style>
